// extracted by mini-css-extract-plugin
module.exports = {"depositResultButton":"_d45b8ce"};